import React from 'react'
import classes from "./styles/footer.module.css";
import logo from "../../assets/logo/fetchjobLogo.png";

import { Link} from 'react-router-dom';

const Footer = () => {

  return (
    <div className={classes.Container}>
        <div className={classes.innerCon}>
          <div className={classes.copyrightDiv}>
            <div className={classes.logoCon}><Link to="/"><img src={logo} alt='fetchJobs-copyright'/></Link></div>
            <p>© 2026 All right reserved.</p>
            <div className={classes.socialDiv}>
              <a href='https://www.instagram.com/hirecrap' target='_blank' rel="noreferrer"><img src={"https://cdn-icons-png.flaticon.com/128/3661/3661391.png"} alt='instagram-logo' /></a>
              <a href='https://www.facebook.com/profile.php?id=61587137117527' target='_blank' rel="noreferrer"><img src={"https://cdn-icons-png.flaticon.com/128/20/20837.png"} className={classes.facebook} alt='facebook-logo' /></a>
              <a href="https://www.linkedin.com/company/fetchjobs-co" target='_blank' rel="noreferrer"><img src={"https://cdn-icons-png.flaticon.com/128/3128/3128219.png"} alt='linkedin-logo'/></a>
              <a href="https://x.com/HIRECRAP_" target='_blank' rel="noreferrer"><img className={classes.twitter} src={"https://cdn-icons-png.flaticon.com/128/5968/5968958.png"} alt='X-logo'/></a>
            </div>
          </div>
      <div className={classes.secondDiv}>
        <Link to='/about'>About</Link>
        <Link to='/contact'>Contact</Link>
      </div>
      <div className={classes.secondDiv}>
        <Link to='/career'>Career</Link>
        <Link to='/privacy'>Privacy</Link>
      </div>
      <div className={classes.secondDiv}>
        <Link to='/jobs'>Jobs</Link>
        <Link to='/blog'>Blog</Link>
      </div>
      </div>
      
    </div>
  )
}

export default Footer;
